export const FETCH_CUSTOMER_PAYMENTS_REQUESTED = 'FETCH_CUSTOMER_PAYMENTS_REQUESTED'
export const FETCH_CUSTOMER_PAYMENTS_SUCCEEDED = 'FETCH_CUSTOMER_PAYMENTS_SUCCEEDED'
export const FETCH_CUSTOMER_PAYMENTS_FAILED = 'FETCH_CUSTOMER_PAYMENTS_FAILED'

export const fetchCustomerPayments = () => ({
  type: FETCH_CUSTOMER_PAYMENTS_REQUESTED,
})

export const fetchCustomerPaymentsSucceeded = (payload) => ({
  type: FETCH_CUSTOMER_PAYMENTS_SUCCEEDED,
  payload,
})

export const fetchCustomerPaymentsFailed = (payload) => ({
  type: FETCH_CUSTOMER_PAYMENTS_FAILED,
  payload,
})
